import { trackAction } from '../analytics/analytics';

let hasLiveChatBeenClicked = false;

// This runs continually and tracks global_chatbot_question and
// global_chatbot_question_active event constantly across pageloads.
let isLiveChatButtonAvailable = false;
let isChatNowButtonAvailable = false;
let hasChatWindowBeenClosedOnPageLoad = false;
setInterval(() => {
  if (document.querySelector('[src$="live_chat_tab.svg"]')) {
    if (!isLiveChatButtonAvailable) {
      trackAction('global_chatbot_question');
    }
    isLiveChatButtonAvailable = true;
  } else {
    isLiveChatButtonAvailable = false;
  }

  if (document.querySelector('[src$="Live_Chat_help-finding_chat-now.svg"]')) {
    if (!isChatNowButtonAvailable) {
      trackAction('global_chatbot_question_active');
    }
    isChatNowButtonAvailable = true;
  } else {
    isChatNowButtonAvailable = false;
  }

  if (!hasChatWindowBeenClosedOnPageLoad) {
    const minimizeButton = document.querySelector(
      '#lpChat .lpc_window .lpc_maximized-header__minimize-button'
    );

    if (minimizeButton && !hasLiveChatBeenClicked) {
      minimizeButton.click();
      hasChatWindowBeenClosedOnPageLoad = true;
    }
  }
}, 5000);

document.body.addEventListener('click', e => {
  const classList = e?.target?.classList;

  if (
    classList &&
    (classList.contains?.('LPMlabel') ||
      classList.contains?.('LPMcontainer') ||
      classList?.contains?.('LPMimage'))
  ) {
    const isPDP = document.querySelector('[class^=product-detail-page]');
    const isPLP = document.querySelector('[class^=product-list-page]');

    let payload = {};

    if (isPDP || isPLP) {
      payload['is_chatbot_fil'] = String(
        document.querySelector('#found-it-lower_chat-btn') ? 1 : 0
      );
    }

    hasLiveChatBeenClicked = true;
    trackAction('global_chatbot_cta_click', payload);
  }
});
